export var EXPAND_COLUMN = {};
export var INTERNAL_HOOKS = 'rc-table-internal-hook';